
import PropTypes from 'prop-types';
import React from 'react';
import Slider from 'react-slick';
import { Box, Container } from 'theme-ui';
import { Themed } from '@theme-ui/mdx';

import CirclesPurpleIcon from '@src/assets/icons/circles-purple.svg';
import FeedbackCard from '@src/components/feedbackCard';

const feedbackSection = ({
  title,
  count,
  feedback,
  quoteColor,
  bgColor = 'primaryPaleBg',
  showCircles = true,
}) => {
  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      {feedback && feedback.length > 0 && (
        <Box className="relative">
          <Box
            bg={bgColor}
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              left: 0,
              bottom: 0,
              zIndex: '-1',
            }}
          />

          {showCircles && (
            <CirclesPurpleIcon className="circle-bottom-left circle-orange" />
          )}

          <Container px={4} py={6}>
            <Themed.h2 sx={{ textAlign: 'center' }}>
              {title} {count && <Themed.a>{`(${count})`}</Themed.a>}
            </Themed.h2>

            <Box pt={4}>
              <Slider {...sliderSettings}>
                {feedback.map((item) => (
                  <FeedbackCard
                    key={item.id}
                    feedback={item}
                    quoteColor={quoteColor}
                  />
                ))}
              </Slider>
            </Box>
          </Container>
        </Box>
      )}
    </>
  );
};

export default feedbackSection;

feedbackSection.propTypes = {
  title: PropTypes.string.isRequired,
  feedback: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      author: PropTypes.string,
      avatar: PropTypes.string,
      text: PropTypes.string,
      price: PropTypes.string,
      rating: PropTypes.string,
      ratingCount: PropTypes.string,
    })
  ).isRequired,
};
